"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TENANT_ESIK_ANAHTARLARI = exports.TENANT_DEGER_ANAHTARLARI = exports.TENANT_LISTE_ANAHTARLARI = exports.TENANT_YETKI_ANAHTARLARI = exports.TENANT_KAPI_ANAHTARLARI = exports.TENANT_ANAHTAR_ETIKETLERI = exports.TENANT_ANAHTAR_SINIFLARI = exports.TENANT_ANAHTAR_SINIFLARI_LISTE = exports.TENANT_ANAHTARLARI = exports.TENANT_SETTING_VARSAYILANLARI = void 0;
exports.tenantSettingDegerIhlali = tenantSettingDegerIhlali;
exports.ayarAnahtariEtiketi = ayarAnahtariEtiketi;
exports.ayarDegeriMetni = ayarDegeriMetni;
const egitim_1 = require("./egitim");
const incident_1 = require("./incident");
const kpi_1 = require("./kpi");
const risk_1 = require("./risk");
const saglik_1 = require("./saglik");
const kkd_1 = require("./kkd");
const ptw_kontrol_matrisi_1 = require("./ptw-kontrol-matrisi");
const yetki_1 = require("./yetki");
const nonconformity_1 = require("./nonconformity");
/**
 * TENANT ANAHTAR KÜTÜĞÜ — YAPILANDIRMA EKRANININ TEK KAYNAĞI
 * (F4·S2; Kapsam §23, ERD §2; tutanak `yapilandirma-ekrani-kararlari-v1_0.md`
 * Y1-Y7 · Z1-Z6).
 *
 * **TEK KÜTÜK KURALI (madde 6).** `TENANT_SETTING_VARSAYILANLARI` bu dosyada
 * durur ve kütüğün KENDİSİDİR; etiket ve sınıf haritaları ondan TÜRETİLİR
 * (`Record<TenantSettingAnahtar, …>` — yeni anahtar eklenip etiketi/sınıfı
 * yazılmazsa TypeScript derlemez, envanter testi de kırmızı yanar).
 * @isg/db onu yalnız YENİDEN İHRAÇ eder — ikinci kütük yoktur.
 *
 * ⚠️ **YERLEŞİM NOTU:** kütük F4·S2'de @isg/db'den buraya TAŞINDI. Gerekçe
 * mekanik: etiketler artık **TAŞIYICIDIR** (Y4 — panel yorum yapmadığına göre
 * kapalı kontrolü anlatan tek şey adıdır) ve web'in de onlara erişmesi
 * gerekir; varsayılanların bağlı olduğu şapka listeleri (`*_YETKI_VARSAYILAN`)
 * zaten bu paketteydi. Kütüğü tekrar db'ye taşıma — web o paketi import
 * etmez.
 *
 * ⚠️ **TEKNİK ADLAR KORUNUR (Kapsam §23/1).** Etiket YALNIZ kullanıcı
 * yüzeyidir; hiçbir anahtarın kod tarafındaki adı etiket yüzünden
 * değişmez (madde 65 / U11'de kurulan kuralın tekrarı).
 */
exports.TENANT_SETTING_VARSAYILANLARI = {
    /** Uzman aksiyon atayabilir mi (Kapsam §22.3/3) — varsayılan AÇIK. */
    uzman_aksiyon_atama: true,
    /**
     * MADDE 54 (✅ 13.08.2026 — Kapsam §7.5): izin QR'ının salt-okunur özetini
     * kimin göreceği. `sirket` (VARSAYILAN) = iznin ŞİRKETİNDE aktif istihdamı
     * olan her iç kullanıcı · `lokasyon` = yalnız okuma kuralının kapsadığı
     * kişiler (taraflar + iznin lokasyon dalını kapsayan bahçe).
     *
     * YERLEŞİM KARARI (F3·S6 ön adımı — ERD §2'nin iki adayından biri seçildi):
     * anahtar `tenant_setting`e kondu, `ptw_authority_config`e DEĞİL. Gerekçe:
     * authority tablosunun şekli (`kind` + `sapka`) bir ŞAPKA LİSTESİDİR, ENUM
     * DEĞERİ taşıyamaz — oraya koymak ya kolon eklemeyi ya da şapka enum'unu
     * kirletmeyi isterdi. `tenant_setting` zaten "tenant düzeyi, satır yoksa
     * varsayılan" ailesidir ve QR kapsamı tam olarak o cinsten bir prosedür
     * tercihidir (izin başına değil — Kapsam §7.5).
     *
     * **HOLDİNG GENİŞLİĞİ YOKTUR** (§15.1): üçüncü bir değer eklemek iki
     * seviye izolasyonu deler — bu listeyi genişletme.
     */
    qr_ozet_kapsami: 'sirket',
    /**
     * U4 (✅ 17.08.2026 — Kapsam §16.8/14-a): anonim olay bildirimi tenant
     * politikası. VARSAYILAN KAPALI — tenant açıkça açar. Anahtar YALNIZ YENİ
     * kaydın açılışını kısıtlar: kapatılırsa mevcut anonim kayıtlar anonim
     * KALIR (kod anonimliği anahtardan değil kayıttan okur — U3,
     * olayAnonimMi).
     */
    anonim_bildirim_acik: false,
    /**
     * U6 liste anahtarları (✅ 17.08.2026 — PTW geri_cekme/saha_kontrol
     * deseninin tenant_setting kolu; yeni tablo YOK). Değer şapka dizisidir.
     * ✏️ T2·0 (01.09.2026 — K9): `olay_kapanis` KALKTI — kapanış türetilir,
     * "kim kapatır" sorusu yok; yetim satırlar migration'da silindi.
     *
     * c1 — BOŞ/EKSİK LİSTE = VARSAYILAN GEÇERLİ: PTW saha kontrolünün
     * "boş = 422" kuralından BİLİNÇLİ SAPMA. Orada boş liste "kurulum eksik"
     * demekti; burada boş liste yüzünden duran şey bildirim/inceleme akışı
     * olurdu ve KAYIT KAYBI 422'DEN PAHALIDIR. İki desen yan yana yaşar —
     * karıştırma.
     */
    olay_inceleme: (0, incident_1.olayYetkiVarsayilani)('olay_inceleme'),
    /**
     * U5 (Tur 2½a — Kapsam §24.1/5): uygunsuzluğu KİM değerlendirir —
     * ret · olaya taşıma. `olay_inceleme`nin birebir kardeşi (boş liste =
     * varsayılan geçerli, c1). DÖF açma bu listeden OKUNMAZ: o, aksiyon
     * kuralının kendisidir (`uzman_aksiyon_atama` rejimi — U6).
     */
    uygunsuzluk_degerlendirme: nonconformity_1.UYGUNSUZLUK_DEGERLENDIRME_VARSAYILAN,
    calisma_saati_giris: (0, incident_1.olayYetkiVarsayilani)('calisma_saati_giris'),
    /**
     * T9 (✅ 18.08.2026 — Kapsam §16.10/13 + §20.5): eğitim kaydı açma/
     * düzenleme/katılımcı işaretleme/ek yönetimi/QR üretme. **TEK ANAHTAR** —
     * eğitim modülü ikinci bir yetki ekseni açmaz.
     */
    egitim_kaydi: egitim_1.EGITIM_YETKI_VARSAYILAN,
    /**
     * Eğitim değerlendirmesi public kanalı (§16.10/9) — **VARSAYILAN AÇIK.**
     * `anonim_bildirim_acik`ın aksine kapalı doğmaz: anonim bildirim tenant'ın
     * açtığı bir POLİTİKAdır, değerlendirme ise **ürünün kendi akışının
     * parçasıdır**. İki anahtar karıştırılmaz.
     */
    egitim_degerlendirme_acik: true,
    /**
     * G5 (Tur 4½ — Kapsam §25/5): görevlendirme için yetkinlik ZORUNLU mu.
     * **VARSAYILAN KAPALI** — açan holdingde eksik yetkinlikle görevlendirme
     * 422; kapalıyken kayıt açılır ve *"eksik"* damgası taşır (damga
     * TÜRETİLİR, saklanmaz).
     *
     * ⚠️ **ASİMETRİ BİLİNÇLİDİR:** gevşek taraf **saha gerçeğidir** — önce
     * görevlendir, sonra eğitime gönder; kapalı doğmasaydı sistem, işyerinin
     * ilkyardımcısı olmadığını *kaydetmeyi bile* engellerdi. Sıkı taraf
     * **holding tercihidir.** `anonim_bildirim_acik` ile aynı aile: ürünün
     * akışı açık doğar, POLİTİKA kapıyı daraltır.
     */
    gorevlendirme_yetkinlik_zorunlu: false,
    /**
     * S2 (✅ 18.08.2026 — Kapsam §16.11/3 + §20.5): sağlık kanaati kaydı/
     * düzeltme, ek yönetimi, çalışma profili ve dışa aktarma yetkisi.
     * **VARSAYILAN OLAY/EĞİTİMDEN FARKLIDIR ve bu bilinçlidir:** kanaat girişi
     * bir sağlık işidir → hekim + YSP + İSG uzmanı.
     */
    saglik_kanaat_giris: saglik_1.SAGLIK_YETKI_VARSAYILAN,
    /**
     * R7 (✅ 18.08.2026 — Kapsam §16.12/10 + §20.5): risk değerlendirmesi
     * açma/düzenleme, madde CRUD, ekip listesi ve SÜRÜM DONDURMA yetkisi.
     * **Hekim listede YOKTUR:** ekibe ÜYE olur (R6) ama kayıt yetkisi için
     * tenant listesine AYRICA eklenir — *ekip üyeliği yetki vermez.*
     */
    risk_degerlendirme: risk_1.RISK_YETKI_VARSAYILAN,
    /**
     * R4 (✅ 18.08.2026 — Kapsam §16.12/2): risk metodolojisi. Değer enum'u
     * (`qr_ozet_kapsami` deseni), varsayılan `matrix_5x5`.
     *
     * **TENANT DÜZEYİNDE ve TEK** — gerekçe konsolidasyon: 5x5'te 25 ile
     * Fine-Kinney'de 400 aynı tabloya giremez. Değerlendirme kaydı bu değeri
     * AÇILIŞTA MİRAS ALIR ve DONDURUR. **`l_type` v1'e GİRMEDİ.**
     */
    risk_metodolojisi: 'matrix_5x5',
    /**
     * R5 (✅ 18.08.2026 — Kapsam §16.12/8): yüksek bantta aksiyonsuz madde
     * SÜRÜM DONDURMAYI engellesin mi. VARSAYILAN **KAPALI** — kural UYARIDIR,
     * müşteri isterse kapıya çevirir. Kapı madde eklerken DEĞİL, dondurmada
     * koşar (yarım kalmış çalışma engellenmez).
     */
    risk_aksiyon_zorunlu: false,
    /**
     * **YENİ (F4·S2 / Y1 — madde 74, O9'un yapılandırma yüzeyi):** majör
     * araştırma gerektiren POTANSİYEL ŞİDDET sırası. Başlangıç **4** —
     * F3B·S1'deki `MAJOR_ARASTIRMA_ESIGI_SIRA` sabitinin BİREBİR karşılığı
     * (sabit KALDIRILDI; davranış değişmedi).
     *
     * **HOLDİNG DÜZEYİNDE — şirkete İNMEZ** (Kapsam §23/3): *"bu çeyrek 12
     * majör araştırma"* cümlesi ancak eşik her yerde aynıysa anlamlıdır.
     * Eşik `sira` DEĞERİNE bağlıdır, kalem id'sine değil (§16.8/4) — merdiven
     * kalemi yeniden adlandırılsa bile bu sayı geçerliliğini korur.
     */
    major_arastirma_esigi: 4,
    /**
     * **YENİ (tur 11 / R4-R5 — 05.09.2026; Kapsam §16.12/8 netleşmesi; madde
     * 129 · 132 kapandı):** risk değerlendirmesinin YENİLEME PERİYODU, tehlike
     * sınıfı ekseninde ay olarak — `{ az, tehlikeli, cok }`.
     *
     * ⚠️ **VARSAYILAN `null` = MEVZUAT TAVANI** (6/4/2 yıl —
     * `RISK_YENILEME_TAVANI_AY`). Boş bırakmak bir eksiklik değil, *"mevzuatın
     * dediği gibi"* demektir.
     *
     * ⚠️ **SIKILAŞTIRILIR, GEVŞETİLMEZ ve bu YAZMA ANINDA reddedilir**
     * (madde 132 → seçenek **a**): tavanı aşan değer **422**'dir. Alternatif
     * (yazdır ama vade türetirken sessizce tavana çek) *"6 yıl yazdım, sistem
     * 2 yıl sayıyor"* ara hâlini üretirdi — §2.40'ın yalan söyleyen kontrolü.
     *
     * ⚠️ **BU ANAHTAR `risk_dof_oneri_esigi`NİN YERİNE GELDİ, ONUN DEVAMI
     * DEĞİL:** o bir EŞİKTİ ve bant tablosunu tekrarlıyordu (R2 — kalktı); bu
     * bir PERİYOTTUR ve hiçbir tabloda karşılığı yoktu.
     */
    risk_yenileme_periyot_ay: null,
    /**
     * **YENİ (T2 tur 2 / T10 — Kapsam §22.3/16):** aksiyon termininden KAÇ GÜN
     * ÖNCE hatırlatma gitsin. **VARSAYILAN `null` = ÖN-UYARI YOK.**
     *
     * ⚠️ Varsayılanın `null` olması bir eksiklik değil bir KARARDIR: bugüne
     * kadar hiç ön-uyarı yoktu ve bir gün sayısı uydurup açmak, her holdingin
     * gelen kutusuna sormadan yeni bir günlük e-posta akışı eklemek olurdu.
     * Müşteri istediğinde açar.
     *
     * ⚠️ **GECİKME BİLDİRİMİ BU AYARDAN BAĞIMSIZDIR** (§22.3/6): termin günü
     * ve sonrası her gün gitmeye devam eder. Ön-uyarı onun YERİNE geçmez,
     * ÖNÜNE eklenir — ayarı kapatan müşteri gecikme uyarısını kaybetmez.
     */
    aksiyon_termin_on_uyari_gun: null,
    /**
     * **YENİ (TUR 12 / K1 — Kapsam §26.1):** dashboard oran KPI'larının
     * çarpanı için **VARSAYILAN**. 200.000 veya 1.000.000.
     *
     * ⚠️ **BU BİR KİLİT DEĞİL, BİR BAŞLANGIÇ DEĞERİDİR ve ayrım turun
     * kararıdır (K1):** çarpan **EKRANDA SÜZGEÇTİR**; ayar yalnız ekranın
     * hangi değerle açılacağını söyler. Kilit olsaydı §16.8.1/2'nin gerekçesi
     * çiğnenirdi — aynı dönem için Suudi ihalesine 200.000'lik, sürdürülebilirlik
     * raporuna 1.000.000'luk oran **EŞZAMANLI** istenir; ayarı değiştirerek
     * ikinci çıktıyı almak, birincinin de anlamını değiştirmek demektir.
     *
     * ⚠️ **HESAPLANMIŞ ORAN YİNE HİÇBİR YERDE SAKLANMAZ** (R12) ve
     * `work_hours_record`'a çarpan kolonu AÇILMAZ.
     */
    kpi_carpan: kpi_1.KPI_CARPAN_VARSAYILAN,
    /**
     * **YENİ (KKD — Kapsam §30/Z3, 07.09.2026):** KKD zimmet formunun ÜST
     * bloğuna basılan MATBU METİN. Standart metni biz veririz
     * (`KKD_ZIMMET_STANDART_METNI` — kısa, iddiasız, mevzuat atfı YOK),
     * müşteri değiştirir. Boş yazılamaz; 2.000 karakter.
     *
     * ⚠️ İlk SERBEST METİN değer anahtarıdır: `tenantSettingDegerIhlali`
     * dize uzunluğunu denetler, içeriğe karışmaz — metin müşterinin hukuki
     * tercihidir. PDF metni SUNUCUDA okur (`readKkdZimmetMetni`); ekran
     * metni PDF'e taşımaz.
     */
    kkd_zimmet_metni: kkd_1.KKD_ZIMMET_STANDART_METNI,
};
/** Kütüğün kendisi — etiket/sınıf haritaları ve panel BUNDAN türer. */
exports.TENANT_ANAHTARLARI = Object.keys(exports.TENANT_SETTING_VARSAYILANLARI);
/**
 * ÜÇ ANAHTAR SINIFI (Kapsam §23/2) — her anahtar TAM OLARAK BİRİNDE.
 * Sınıf yalnız etiketin dil biçimini seçmez; **panelin kapsamını da o
 * belirler** (Y7: panel yalnız `kapi` sınıfını gösterir).
 */
exports.TENANT_ANAHTAR_SINIFLARI_LISTE = ['kapi', 'yetki', 'liste', 'deger'];
/**
 * ✏️ DİLİM 2 (15.09.2026 — Kapsam §23/2a ✏️; bulgu 76 · envanter §5/5): KAPI
 * SINIFI İKİYE BÖLÜNDÜ. `kapi` = bir KONTROLÜ açıp kapatır (panelde sayılır);
 * `yetki` = bir YETKİYİ ya da KANALI açar (ayrı "Yetki anahtarları" kartı,
 * panele GİRMEZ — yetki/kanal anahtarının kapalı olması bir kontrolün kapalı
 * olması değildir). İkisi de boolean; dil biçimi aynı (cümle).
 */
exports.TENANT_ANAHTAR_SINIFLARI = {
    risk_aksiyon_zorunlu: 'kapi',
    uzman_aksiyon_atama: 'yetki',
    anonim_bildirim_acik: 'yetki',
    egitim_degerlendirme_acik: 'yetki',
    gorevlendirme_yetkinlik_zorunlu: 'kapi',
    olay_inceleme: 'liste',
    calisma_saati_giris: 'liste',
    egitim_kaydi: 'liste',
    saglik_kanaat_giris: 'liste',
    risk_degerlendirme: 'liste',
    uygunsuzluk_degerlendirme: 'liste',
    qr_ozet_kapsami: 'deger',
    risk_metodolojisi: 'deger',
    major_arastirma_esigi: 'deger',
    risk_yenileme_periyot_ay: 'deger',
    aksiyon_termin_on_uyari_gun: 'deger',
    kpi_carpan: 'deger',
    kkd_zimmet_metni: 'deger',
};
/**
 * ETİKETLER — ürün sahibi onaylı, BİREBİR (Kapsam §23/2a-2c, madde 65 ✅
 * 21.08.2026). Üç dil biçimi: kapı → açıkken ne olduğunu söyleyen CÜMLE ·
 * liste → "…-ebilenler" · değer/eşik → isim tamlaması.
 *
 * ⚠️ **ETİKETSİZ ANAHTAR SESSİZ BİR BOŞLUKTUR** (Y4): panel yorum
 * yapmadığına göre kapalı bir kontrolü anlatan tek şey adıdır. Metni
 * "iyileştirme" diye değiştirme — onaylı liste budur.
 */
exports.TENANT_ANAHTAR_ETIKETLERI = {
    risk_aksiyon_zorunlu: 'Yüksek puanlı risk maddesi aksiyonsuz bırakılamaz',
    uzman_aksiyon_atama: 'İSG ekibi doğrudan aksiyon açabilir',
    anonim_bildirim_acik: 'Anonim bildirim sayfası açık',
    egitim_degerlendirme_acik: 'Katılımcı eğitimi değerlendirebilir',
    // ✏️ DİLİM 2 (15.09.2026 — bulgu 76; Kapsam §23/2a ✏️): eski etiket
    // ("Görevlendirme için yetkinlik zorunlu") iş izni katılımcı kontrolüyle
    // karıştırılıyordu — o kontrol anahtarla değil KONTROL MATRİSİNDEN yönetilir.
    gorevlendirme_yetkinlik_zorunlu: 'Kişi kartında görev verirken belge aranır (kurul üyesi, operatör…)',
    olay_inceleme: 'Olay inceleyebilenler',
    calisma_saati_giris: 'Çalışma saati girebilenler',
    egitim_kaydi: 'Eğitim kaydı girebilenler',
    saglik_kanaat_giris: 'Sağlık kanaati girebilenler',
    risk_degerlendirme: 'Risk değerlendirmesi yapabilenler',
    uygunsuzluk_degerlendirme: 'Uygunsuzluk değerlendirebilenler',
    qr_ozet_kapsami: 'QR kartının görünürlük kapsamı',
    risk_metodolojisi: 'Risk değerlendirme yöntemi',
    major_arastirma_esigi: 'Majör araştırma gerektiren şiddet seviyesi',
    risk_yenileme_periyot_ay: 'Risk değerlendirmesi yenileme periyodu (ay)',
    aksiyon_termin_on_uyari_gun: 'Aksiyon termininden kaç gün önce hatırlatılsın',
    kpi_carpan: 'Oran KPI çarpanının varsayılanı',
    kkd_zimmet_metni: 'KKD zimmet formunun matbu metni',
};
function sinifAnahtarlari(sinif) {
    return exports.TENANT_ANAHTARLARI.filter((a) => exports.TENANT_ANAHTAR_SINIFLARI[a] === sinif);
}
/** Panelin TEK kaynağı (Y7) — liste, değer VE (✏️ dilim 2) yetki anahtarları
 *  buraya GİRMEZ: panel yalnız KONTROL sınıfını sayar. */
exports.TENANT_KAPI_ANAHTARLARI = sinifAnahtarlari('kapi');
/** ✏️ Dilim 2 — "Yetki anahtarları" kartının TEK kaynağı. */
exports.TENANT_YETKI_ANAHTARLARI = sinifAnahtarlari('yetki');
exports.TENANT_LISTE_ANAHTARLARI = sinifAnahtarlari('liste');
exports.TENANT_DEGER_ANAHTARLARI = sinifAnahtarlari('deger');
/** Sayı değerli EŞİK anahtarları — Z2'nin iki okuyucusu bunları alır. */
exports.TENANT_ESIK_ANAHTARLARI = [
    'major_arastirma_esigi',
    'aksiyon_termin_on_uyari_gun',
];
// ── Değer guard'ı (yazma kapısı — 422) ──────────────────────────────────────
/**
 * PUT gövdesinin ANAHTARA GÖRE doğrulanması. Şema tek başına yetmez: aynı uç
 * boolean · şapka dizisi · enum · sayı taşır, ve `major_arastirma_esigi = 99`
 * gibi bir değer rozeti **sessizce** kapatırdı (Teknoloji §9 — ölçtüğünü
 * sandığı şeyi ölçmeyen gösterge). İhlal KURAL eksenidir → 422.
 *
 * Liste anahtarlarının taban kilidi burada TEKRARLANMAZ — o kural
 * `*YetkiListesiIhlali` yüklemlerindedir ve `writeTenantSetting` onu ayrıca
 * çağırır (tek yüklem ilkesi).
 */
function tenantSettingDegerIhlali(anahtar, deger) {
    const sinif = exports.TENANT_ANAHTAR_SINIFLARI[anahtar];
    if (sinif === 'kapi' || sinif === 'yetki') {
        return typeof deger === 'boolean' ? null : 'Bu ayar yalnız açık/kapalı değer alır';
    }
    if (sinif === 'liste') {
        if (!Array.isArray(deger) || deger.some((s) => typeof s !== 'string')) {
            return 'Bu ayar şapka listesi alır';
        }
        const liste = deger;
        if (anahtar === 'egitim_kaydi')
            return (0, egitim_1.egitimYetkiListesiIhlali)(liste);
        if (anahtar === 'saglik_kanaat_giris')
            return (0, saglik_1.saglikYetkiListesiIhlali)(liste);
        if (anahtar === 'risk_degerlendirme')
            return (0, risk_1.riskYetkiListesiIhlali)(liste);
        if (anahtar === 'uygunsuzluk_degerlendirme')
            return (0, nonconformity_1.uygunsuzlukYetkiListesiIhlali)(liste);
        return (0, incident_1.olayYetkiListesiIhlali)(anahtar, liste);
    }
    if (anahtar === 'qr_ozet_kapsami') {
        return deger === 'sirket' || deger === 'lokasyon'
            ? null
            : 'QR kapsamı yalnız şirket veya lokasyon olabilir';
    }
    if (anahtar === 'risk_metodolojisi') {
        return typeof deger === 'string' && risk_1.RISK_METODOLOJILERI.includes(deger)
            ? null
            : 'Tanınmayan risk metodolojisi';
    }
    if (anahtar === 'major_arastirma_esigi') {
        return typeof deger === 'number' && Number.isInteger(deger) && deger >= 0 && deger <= 5
            ? null
            : 'Majör araştırma eşiği 0-5 arası bir şiddet sırasıdır';
    }
    if (anahtar === 'aksiyon_termin_on_uyari_gun') {
        // null = ön-uyarı YOK (kapalı). Üst sınır 90 gün: daha uzağı bir
        // "hatırlatma" değil gürültüdür ve `major_arastirma_esigi = 99`
        // vakasının aynısını üretirdi (Teknoloji §9).
        if (deger === null)
            return null;
        return typeof deger === 'number' && Number.isInteger(deger) && deger >= 1 && deger <= 90
            ? null
            : 'Ön-uyarı 1-90 gün arası bir sayıdır (boş bırakılırsa ön-uyarı gönderilmez)';
    }
    if (anahtar === 'kkd_zimmet_metni') {
        // Z3 — serbest metin: yalnız BİÇİM denetlenir (boş değil · üst sınır);
        // içerik müşterinin hukuki tercihidir, ürün ona karışmaz.
        if (typeof deger !== 'string' || deger.trim().length === 0) {
            return 'Zimmet formu metni boş bırakılamaz';
        }
        return deger.length <= kkd_1.KKD_ZIMMET_METNI_MAX
            ? null
            : `Zimmet formu metni en çok ${kkd_1.KKD_ZIMMET_METNI_MAX} karakter olabilir`;
    }
    if (anahtar === 'kpi_carpan') {
        // ⚠️ İKİ DEĞERDEN BİRİ (K1) — serbest sayı DEĞİL: çarpan bir ölçek
        // birimidir ve uydurulmuş bir değer (ör. 500.000) hiçbir müşterinin
        // oranıyla kıyaslanamaz. Liste `@isg/validation kpi.ts`ten okunur.
        return kpi_1.KPI_CARPANLARI.includes(deger)
            ? null
            : 'Çarpan yalnız 200.000 veya 1.000.000 olabilir';
    }
    // risk_yenileme_periyot_ay — null = MEVZUAT TAVANI (varsayılana dönüş).
    //
    // ⚠️ TAVAN BURADA KOŞAR (madde 132 → a): sıkılaştırma serbest, gevşetme
    // 422. Sayılar `RISK_YENILEME_TAVANI_AY`den okunur — ikinci sabit yazılmaz.
    if (deger === null)
        return null;
    if (typeof deger !== 'object' || deger === null || Array.isArray(deger)) {
        return 'Yenileme periyodu üç tehlike sınıfı için ay cinsinden verilir (az · tehlikeli · çok)';
    }
    const harita = deger;
    for (const alan of ['az', 'tehlikeli', 'cok']) {
        if (typeof harita[alan] !== 'number') {
            return 'Yenileme periyodu üç tehlike sınıfı için ay cinsinden verilir (az · tehlikeli · çok)';
        }
    }
    const ihlaller = (0, risk_1.riskYenilemePeriyotIhlalleri)(harita);
    return ihlaller.length > 0 ? ihlaller.join(' · ') : null;
}
// ── Ayar defteri gösterimi (dilim 2 — K-73g) ────────────────────────────────
/** Defter satırının anahtar adı — tenant anahtarında onaylı etiket (§23/2),
 *  matris satırında sabit ad. Teknik ad kullanıcıya gösterilmez (§23/1). */
function ayarAnahtariEtiketi(anahtar) {
    if (anahtar === ptw_kontrol_matrisi_1.PTW_KONTROL_MATRISI_ANAHTARI)
        return 'İş izni kontrol matrisi';
    return Object.hasOwn(exports.TENANT_ANAHTAR_ETIKETLERI, anahtar)
        ? exports.TENANT_ANAHTAR_ETIKETLERI[anahtar]
        : anahtar;
}
/**
 * Defterdeki eski/yeni değerin OKUNUR hâli — ekran ve olası çıktı aynı
 * cümleyi basar. `null`: tenant anahtarında VARSAYILAN (satır yoktu),
 * işyeri matris hücresinde DEVRAL, holding matris hücresinde KAPALI (K-73c).
 */
function ayarDegeriMetni(anahtar, deger, kapsam = 'holding') {
    if (anahtar === ptw_kontrol_matrisi_1.PTW_KONTROL_MATRISI_ANAHTARI) {
        if (deger === null || deger === undefined)
            return kapsam === 'isyeri' ? 'Devral' : 'Kapalı';
        if (deger === 'acik')
            return 'Açık';
        if (deger === 'kapali')
            return 'Kapalı';
        return String(deger);
    }
    if (deger === null || deger === undefined)
        return 'Varsayılan';
    if (typeof deger === 'boolean')
        return deger ? 'Açık' : 'Kapalı';
    if (Array.isArray(deger)) {
        return deger.length === 0
            ? 'Varsayılan'
            : deger
                .map((sapka) => Object.hasOwn(yetki_1.SAPKA_ETIKETI, String(sapka))
                ? yetki_1.SAPKA_ETIKETI[sapka]
                : String(sapka))
                .join(', ');
    }
    if (typeof deger === 'object') {
        return Object.entries(deger)
            .map(([alan, v]) => `${alan}: ${String(v)}`)
            .join(' · ');
    }
    return String(deger);
}
//# sourceMappingURL=tenant-settings.js.map